module.exports = __webpack_public_path__ + "img/Difarmer-preguntas-frecuentes-1.77763089.png";